'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { BREAKPOINTS, DONATION_ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { FooterMobile } from './_components/FooterMobile';
import { FooterPc } from './_components/FooterPc';
export const Footer = () => {
  const $ = _c(6);
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const pathname = usePathname();
  let t0;
  bb0: switch (pathname) {
    case DONATION_ROUTES.GIFTS.pathname:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            pc: "pb-100",
            mobile: "pb-150"
          };
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        t0 = t1;
        break bb0;
      }
    default:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            pc: "",
            mobile: ""
          };
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        t0 = t1;
      }
  }
  const className = t0;
  let t1;
  if ($[2] !== className.mobile || $[3] !== className.pc || $[4] !== isDesktopViewport) {
    t1 = isDesktopViewport ? <FooterPc className={className.pc} /> : <FooterMobile className={className.mobile} />;
    $[2] = className.mobile;
    $[3] = className.pc;
    $[4] = isDesktopViewport;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};